import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Reveal } from "@/components/site/Motion";
import { openBroby } from "@/components/site/BrobyChat";
import { useLang } from "@/lib/i18n";

export default function Faq() {
  const { t } = useLang();

  return (
    <section id="faq" className="py-16 md:py-24 bg-muted/50" data-testid="faq-section">
      <div className="max-w-[1400px] mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-[1fr_1.4fr] gap-10 lg:gap-16 items-start">
          <Reveal>
            <div>
              <div className="chip">{t("faq.chip")}</div>
              <h2 className="mt-4 font-heading text-3xl md:text-5xl leading-[1.05]">
                {t("faq.title_1")} <span className="text-primary">{t("faq.title_accent")}</span>
              </h2>
              <p className="mt-4 text-lg text-foreground/75 leading-relaxed">{t("faq.subtitle")}</p>
              <div className="mt-8 rounded-3xl bg-white border border-border p-6 md:p-7">
                <p className="font-heading text-xl">{t("faq.more")}</p>
                <button
                  onClick={openBroby}
                  data-testid="faq-ask-broby"
                  className="mt-4 pill-btn bg-primary text-primary-foreground hover:opacity-90"
                >
                  {t("faq.ask")}
                </button>
              </div>
            </div>
          </Reveal>
          <Reveal delay={0.08}>
            <Accordion type="single" collapsible className="space-y-3" data-testid="faq-accordion">
              {[1, 2, 3, 4, 5, 6].map((n) => (
                <AccordionItem
                  key={n}
                  value={`q${n}`}
                  data-testid={`faq-item-${n}`}
                  className="rounded-3xl bg-white border border-border border-b px-5 md:px-6 data-[state=open]:border-primary/40 transition-colors"
                >
                  <AccordionTrigger
                    data-testid={`faq-question-${n}`}
                    className="text-left font-heading text-base md:text-lg hover:no-underline py-5"
                  >
                    {t(`faq.${n}.q`)}
                  </AccordionTrigger>
                  <AccordionContent
                    data-testid={`faq-answer-${n}`}
                    className="text-base text-foreground/75 leading-relaxed pb-5"
                  >
                    {t(`faq.${n}.a`)}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
